import Utils from '../common/Utils';
import {GLOBAL_PATH, STORE } from '../common/Model';
import {communityHomeL10n} from "../common/L10n";

export default class Appdown {
	constructor(_config) {

		this.config = _config;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'appdown',
			locale : this.config.locale,
			country : this.config.country
		};
		this.appdownApiUrl = GLOBAL_PATH(_option);
		this.l10n = communityHomeL10n[this.config.lang];

	}
	init() {
		if (Utils.isEmptyObject(STORE.data.appdown)) {
			this.get();
		} else {
			this.render(STORE.data.appdown);
		}
	}

	get() {
		const _this =  this;
		fetch(this.appdownApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (data) { // This is the JSON from our response
			// console.log(data);
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.appdown = _resData;
			this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
			_this.container.innerHTML = `<div class="myfeed-message-wrap"><p class="myfeed-message-desc">${_this.l10n.pageError}</p></div>`;
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.appdownApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.appdown = _resData;
			this.render(_resData);
		});*/
	}
	render(data) {
		const wrappers = document.querySelectorAll('.home-appdown-quick, .home-appdown');
		let tmpl;
		if( data.appList ) { // 앱리스트 개선
			tmpl = this.templ(data);
		}
		wrappers.forEach( el => {
			el.innerHTML = tmpl;
		});
	}

	templ(_d){
		return `${_d.isActive ?
				`<ul class="appdown-list">
					${_d.appList.map( (_item, _index) => {
					return this.listTempl(_item);
				}).join('')}
				</ul>` : ``}`;
	}

	listTempl(_a) {
		return `
			<li class="appdown-${_a.os} appdown-${_a.device} ${_a.hasQuickmenu ? `appdown-has-quick` : ``}">
				<a href="${_a.url}" ${_a.target ? `target="_blank"` : ``}>
				<img src="${_a.img}" alt="${_a.name}">
				</a>
			</li>`;
	}

}